/* Impression SCDM — LE PRIX EN DIRECT DANS LE CONFIGURATEUR (11 septembre 2026)

   POURQUOI CE FICHIER EXISTE
   --------------------------
   Le configurateur ne montrait AUCUN prix. Une configuration complete — 6 po,
   carre, blanc mat, sans vernis, cent exemplaires — n affichait que des
   supplements isoles (1,25 $, 2,61 $, 15,25 $ le pied carre) et un total de
   commande a 0,00 $. Le prix n apparaissait qu APRES le clic sur « Ajouter a
   ma commande ». Le client devait s engager pour savoir ce qu il payait.

   CE FICHIER NE CALCULE RIEN. C EST LE POINT LE PLUS IMPORTANT.
   -------------------------------------------------------------
   Il n y a pas une seule multiplication de prix ici. Le prix vient d un seul
   appel a window.SCDM.calcul() — la fonction que scdm.js utilise deja pour
   remplir le panier, le bordereau et la facture. On ne fait que l appeler PLUS
   TOT et AFFICHER ce qu elle rend.

   S il avait fallu refaire le calcul, il y aurait eu deux verites possibles
   dans le site, et un jour elles se seraient contredites : le client aurait vu
   un prix et en aurait paye un autre. Au Quebec, un prix annonce doit etre
   honore. Une seule source, donc, et c est scdm.js.

   L ORDRE COMPTE. scdm-panneau.js ecoute en CAPTURE et reecrit le tarif de la
   matiere avant chaque calcul (support rigide, panneau routier). En ecoutant
   en phase de BULLE, on passe forcement apres lui : quand on appelle
   calcul(), la table est deja a jour. On ne l appelle jamais nous-memes.

   CE QU IL AFFICHE
   ----------------
   1. Le prix unitaire et le total de la ligne, deux lignes distinctes.
   2. L ecart quand le client change une option : « +13,20 $ avec le vernis
      mat ». On le calcule en soustrayant deux totaux rendus par calcul() —
      c est une difference, pas un prix.
   3. L avertissement du minimum de commande, DANS le configurateur, des que
      la commande projetee passe sous le plancher. Il n apparaissait qu a la
      fenetre d approbation, trop tard.

   QUAND IL SE TAIT. Tant que le format, le materiau ou la quantite manquent,
   il n y a pas de prix a montrer : on affiche l invitation a finir, pas un
   chiffre faux. La detection n est PAS recodee — on lit le pont en lecture
   seule de scdm-vierge.js (window.SCDM_VIERGE), le meme que le bouton d ajout.

   LA BARRE DE scdm-configurateur-clarte.js. Elle recopie #scdmCmdTotal, qui
   est le total de la COMMANDE (les designs deja ajoutes). Notre panneau montre
   le prix de la LIGNE en cours : deux choses differentes, toutes les deux
   utiles — mais empilees au meme endroit, le client lit deux montants sans
   savoir lequel le concerne.

   LA REGLE : une seule chose collee au bas de l ecran a la fois, et c est le
   prix en direct qui passe devant, parce qu il parle de ce que le client est
   en train de faire. Des que notre panneau est reellement colle, on pose la
   classe « scdm-px-colle » sur la racine .scdm ; la feuille jumelle efface la
   barre tant qu elle est la, et la rend des qu on la retire.

   POURQUOI PAR UNE CLASSE ET PAS EN MODIFIANT L AUTRE FICHIER. Une regle de
   feuille de style ne peut pas se desynchroniser : elle s applique au moment
   ou le navigateur peint, pas au moment ou un minuteur passe. La barre garde
   sa logique entiere, intacte, et continue de fonctionner exactement comme
   avant si notre fichier n est pas charge — il n y a alors aucune classe, donc
   aucune regle qui mord.

   Charge depuis sections/scdm-configurateur.liquid, en defer, avec sa feuille
   jumelle assets/scdm-prix-direct.css. */

(function () {
  'use strict';

  var PANNEAU = null, elUnit = null, elUnitLabel = null, elTotal = null, elEcart = null,
      elMin = null, elAttente = null, elCorps = null, elDevis = null;

  /* L etat precedent, pour l ecart. On garde la SIGNATURE de la configuration
     et le total qu elle valait. Rien d autre : pas de cache de prix, pas de
     table parallele. */
  var dernier = null;
  var ecartJusqua = 0;          /* horodatage : l ecart s efface tout seul */
  var DUREE_ECART = 7000;       /* ms */

  function id(x) { return document.getElementById(x); }
  function S() { return window.SCDM; }
  function D() { return window.SCDM_DATA; }

  function texteAlerte(cle, repli, params) {
    var pont = id('scdmConfigAlertsI18n');
    var texte = (pont && pont.getAttribute('data-' + cle)) || repli;
    return texte.replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }

  function htmlAlerte(texte) {
    return String(texte).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function libelleTraduit(liste, val, repli) {
    var familles = { MATIERES:'material', FORMES:'shape', FINITIONS:'finish', LAMINAGES:'lamination' };
    var racine = id('scdmConfig');
    var cle = 'data-config-choice_' + familles[liste] + '_' + String(val).replace(/-/g, '_') + '_label';
    return (racine && racine.getAttribute(cle)) || repli;
  }

  /* Le meme formatage que scdm.js : deux decimales, virgule, espace, dollar. */
  function argent(n) { return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' $'; }

  function langue(fr, en) {
    return /^en(?:-|$)/i.test(document.documentElement.lang || '') ? en : fr;
  }

  function libelleTotal() {
    var pont = id('scdmConfigDisplayI18n');
    var texte = (pont && pont.getAttribute('data-line_total')) || 'Total de cette ligne';
    return texte.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function prixAffiche(c) {
    if (!c || !Number.isSafeInteger(c.qte) || c.qte <= 0 ||
        !Number.isFinite(c.total) || c.total < 0 || !Number.isSafeInteger(Math.round(c.total * 100))) return null;
    var unitaire = c.total / c.qte;
    var arrondi = Math.round(unitaire * 100);
    var approximatif = arrondi * c.qte !== Math.round(c.total * 100);
    return { unitaire: unitaire, approximatif: approximatif,
      libelle: approximatif ? langue('Prix unitaire moyen', 'Average unit price') : langue('Prix unitaire', 'Unit price') };
  }

  /* ==================================================================
     CE QUI MANQUE ENCORE
     ==================================================================
     On ne montre un prix que si le FORMAT, le MATERIAU et la QUANTITE sont
     choisis : ce sont les trois dont le prix depend vraiment. La forme est
     gratuite et le vernis a une valeur par defaut ; attendre ces deux-la
     ferait taire le panneau pour rien.

     La liste des groupes vides vient de scdm-vierge.js. On ne la recalcule
     pas : deux detections finiraient par diverger, et le client verrait un
     prix pendant que le bouton reste gris. */
  var REQUIS = ['format', 'matiere', 'quantite'];
  var NOMS = { format: 'le format', matiere: 'le matériau', quantite: 'la quantité' };
  var NOMS_EN = { format: 'the size', matiere: 'the material', quantite: 'the quantity' };

  function manquePourLePrix() {
    var V = window.SCDM_VIERGE;
    if (!V || typeof V.manquantsCles !== 'function') return [];
    var cles = V.manquantsCles() || [];
    var out = [];
    REQUIS.forEach(function (r) { if (cles.indexOf(r) >= 0) out.push(langue(NOMS[r], NOMS_EN[r])); });
    return out;
  }

  /* ==================================================================
     LA SIGNATURE DE LA CONFIGURATION
     ==================================================================
     Ce qui, s il change, peut changer le prix. Le nom du design et le fichier
     televerse n en font pas partie : ils ne coutent rien.

     Le support rigide est lu dans le DOM parce que scdm-panneau.js garde son
     choix pour lui. La case retenue porte la classe « on », comme toutes les
     cases du configurateur. */
  function supportChoisi() {
    var c = document.querySelector('#scdmSupports .opt.on, #scdmSupports .on');
    if (!c) return '';
    return c.getAttribute('data-support') || c.getAttribute('data-id') ||
           (c.textContent || '').trim();
  }

  function signature(e) {
    return [e.taille, e.larg, e.haut, e.qte, e.forme, e.matiere, e.finition,
            e.laminage, supportChoisi()].join('|');
  }

  /* ==================================================================
     L ECART : « +13,20 $ avec le vernis mat »
     ==================================================================
     Quel champ a change ? On compare champ par champ avec la signature
     precedente. Si un seul a bouge, on le nomme ; si plusieurs ont bouge d un
     coup, on donne le montant sans le nommer plutot que de nommer au hasard.

     Le libelle vient toujours de scdm-data.js — jamais d une chaine ecrite
     ici. Le jour ou le proprietaire renomme une matiere, l ecart la renomme
     avec lui. */
  var CHAMPS = ['taille', 'larg', 'haut', 'qte', 'forme', 'matiere', 'finition', 'laminage', 'support'];

  function valeurs(e) {
    return { taille: e.taille, larg: e.larg, haut: e.haut, qte: e.qte,
             forme: e.forme, matiere: e.matiere, finition: e.finition,
             laminage: e.laminage, support: supportChoisi() };
  }

  function libelleDe(liste, val) {
    var l = (D() && D()[liste]) || [];
    for (var i = 0; i < l.length; i++) if (l[i].id === val) return l[i].label;
    return null;
  }

  /* La phrase qui suit le montant. Elle dit « avec » quand on ajoute quelque
     chose et « sans » quand on l enleve : « sans vernis » se lit mieux que
     « avec sans vernis ». */
  function commentDire(champ, val, e) {
    var lb;
    if (champ === 'matiere')  { lb = libelleDe('MATIERES', val);  return lb ? texteAlerte('delta_material', 'en {label}', {label:minus(libelleTraduit('MATIERES', val, lb))}) : null; }
    if (champ === 'forme')    { lb = libelleDe('FORMES', val);    return lb ? texteAlerte('delta_shape', 'en découpe {label}', {label:minus(libelleTraduit('FORMES', val, lb))}) : null; }
    if (champ === 'finition') {
      lb = libelleDe('FINITIONS', val);
      if (!lb) return null;
      return /^sans/i.test(lb) ? minus(libelleTraduit('FINITIONS', val, lb)) : texteAlerte('delta_finish', 'avec le {label}', {label:minus(libelleTraduit('FINITIONS', val, lb))});
    }
    if (champ === 'laminage') {
      lb = libelleDe('LAMINAGES', val);
      return lb ? texteAlerte('delta_lamination', 'avec la {label}', {label:minus(libelleTraduit('LAMINAGES', val, lb))}) : texteAlerte('without_lamination', 'sans la pellicule de protection');
    }
    if (champ === 'support') {
      if (!val) return texteAlerte('without_support', 'sans support rigide');
      return texteAlerte('delta_support', 'sur {label}', {label:val});
    }
    if (champ === 'qte') {
      if (!Number.isFinite(val) || val <= 0 || !Number.isInteger(val)) return null;
      return texteAlerte(val > 1 ? 'delta_copies' : 'delta_copy', langue('à ' + val + (val > 1 ? ' exemplaires' : ' exemplaire'),
        'for ' + val + (val > 1 ? ' copies' : ' copy')), {count:val});
    }
    if (champ === 'taille' || champ === 'larg' || champ === 'haut') {
      lb = libelleDe('TAILLES', e.taille);
      return lb ? texteAlerte('delta_size', 'en {label}', {label:lb}) : texteAlerte('selected_size', 'à ce format');
    }
    return null;
  }

  function minus(s) { return s ? s.charAt(0).toLowerCase() + s.slice(1) : s; }

  function texteEcart(avant, apres, vAvant, vApres, e) {
    var d = apres - avant;
    if (!(Math.abs(d) >= 0.005)) return '';
    var changes = CHAMPS.filter(function (c) { return String(vAvant[c]) !== String(vApres[c]); });
    var montant = (d > 0 ? '+' : '−') + argent(Math.abs(d));
    if (changes.length !== 1) return montant + texteAlerte('for_line', ' pour cette ligne');
    var dire = commentDire(changes[0], vApres[changes[0]], e);
    return dire ? montant + ' ' + dire : montant + texteAlerte('for_line', ' pour cette ligne');
  }

  /* ==================================================================
     LE MINIMUM DE COMMANDE, VU DEPUIS LE CONFIGURATEUR
     ==================================================================
     scdm.js applique le plancher au niveau de la COMMANDE, dans
     totauxCommande() : designs deja ajoutes + montage du laminage. Le client
     ne le voyait qu a l approbation, apres avoir tout configure.

     On projette donc : ce que la commande vaut deja, plus la ligne en cours,
     plus le montage que cette ligne ajouterait si elle est la premiere a
     demander une pellicule. Si le total projete reste sous le plancher, on le
     dit ici, tout de suite.

     LE MONTAGE : totauxCommande() ne compte QUE LE PLUS ELEVE des montages,
     une seule fois par commande. On reproduit cette regle telle quelle — et
     seulement si la rangee du laminage est reellement a l ecran, puisque
     scdm.js ignore un laminage dont la rangee est cachee. */
  function laminageVisible() {
    var h = id('scdmLaminages');
    if (!h) return false;
    var n = (h.closest && h.closest('.fld')) || h;
    while (n && n.nodeType === 1) {
      if (n.hidden) return false;
      if (n.style && n.style.display === 'none') return false;
      if (n.id === 'scdmConfig') break;
      n = n.parentElement;
    }
    return true;
  }

  function montageAjoute(dejaCompte) {
    if (!laminageVisible()) return 0;
    var e = S().etat, liste = (D().LAMINAGES || []);
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].id !== e.laminage) continue;
      var f = Number(liste[i].fixeCommande);
      if (!isFinite(f) || f <= 0) return 0;
      return Math.max(dejaCompte, f) - dejaCompte;
    }
    return 0;
  }

  /* ==================================================================
     LE PANNEAU
     ================================================================== */
  function poser() {
    if (PANNEAU && document.body.contains(PANNEAU)) return true;
    var bouton = id('scdmAjouter');
    if (!bouton) return false;
    var bloc = bouton.closest ? bouton.closest('.panneau-ajout') : bouton.parentElement;
    var colonne = bloc && bloc.parentElement;      /* .cfg-form */
    if (!colonne) return false;

    PANNEAU = document.createElement('div');
    PANNEAU.id = 'scdmPxPanneau';
    PANNEAU.className = 'scdm-px plein';
    PANNEAU.setAttribute('role', 'status');
    PANNEAU.setAttribute('aria-live', 'polite');
    PANNEAU.innerHTML =
      '<div class="scdm-px-attente" id="scdmPxAttente"></div>' +
      '<div class="scdm-px-devis" id="scdmPxDevis" hidden></div>' +
      '<div class="scdm-px-corps" id="scdmPxCorps" hidden>' +
        '<div class="scdm-px-l1"><span class="e" id="scdmPxUnitLabel">' + langue('Prix unitaire', 'Unit price') + '</span>' +
          '<strong class="u" id="scdmPxUnit">—</strong></div>' +
        '<div class="scdm-px-l2"><span class="e">' + libelleTotal() + '</span>' +
          '<strong class="t" id="scdmPxTotal">—</strong></div>' +
      '</div>' +
      '<p class="scdm-px-ecart" id="scdmPxEcart" hidden></p>' +
      '<p class="scdm-px-min" id="scdmPxMin" hidden></p>';

    /* AVANT le bloc du bouton, et dans la COLONNE des options : c est ce qui
       permet au panneau de rester colle au bas de l ecran pendant tout le
       defilement des options, puis de venir se ranger juste au-dessus du
       bouton a la fin. Pose par insertion pure : aucun noeud existant n est
       deplace, renomme ni retire. */
    colonne.insertBefore(PANNEAU, bloc);
    replacer();

    elUnit = id('scdmPxUnit'); elUnitLabel = id('scdmPxUnitLabel'); elTotal = id('scdmPxTotal');
    elEcart = id('scdmPxEcart'); elMin = id('scdmPxMin');
    elAttente = id('scdmPxAttente'); elCorps = id('scdmPxCorps');
    elDevis = id('scdmPxDevis');
    return true;
  }

  /* LE PANNEAU DOIT RESTER LA DERNIERE CHOSE AVANT LE BOUTON.

     Trois autres modules s inserent dans cette colonne apres nous et visent le
     meme point d ancrage, le bloc .panneau-ajout : scdm-panneau.js y pose la
     rangee du support rigide, scdm-finition.js celle de la decoupe, et
     scdm-normes.js son avis. Celui qui arrive en dernier se retrouve le plus
     pres du bouton, et l ordre depend donc de qui a fini de se charger en
     premier — ce qui n est pas une facon de decider de la mise en page.

     On se remet donc a notre place a chaque passage : juste avant le bloc du
     bouton, apres toutes les rangees d options. C est la seule position qui a
     un sens, parce que le prix doit tenir compte de TOUS les choix, y compris
     du support rigide qui est pose juste au-dessus.

     ON NE DEPLACE JAMAIS LE NOEUD D UN AUTRE MODULE : on ne bouge que le
     notre, et seulement s il n est pas deja au bon endroit — un deplacement
     inutile a chaque tour du minuteur ferait sauter le defilement. */
  function replacer() {
    if (!PANNEAU) return;
    var bloc = PANNEAU.parentElement &&
               PANNEAU.parentElement.querySelector(':scope > .panneau-ajout');
    if (!bloc) return;
    if (bloc.previousElementSibling === PANNEAU) return;
    PANNEAU.parentElement.insertBefore(PANNEAU, bloc);
  }

  /* Vrai quand le panneau est REELLEMENT colle au bas de l ecran. On mesure
     plutot que de deviner : « sticky » ne previent personne quand il prend ou
     lache sa prise, et la seule facon honnete de savoir est de regarder ou le
     panneau se trouve. */
  function occupeLeBas() {
    if (!PANNEAU || PANNEAU.hidden) return false;
    var r = PANNEAU.getBoundingClientRect();
    var h = window.innerHeight || 0;
    if (!h || r.height === 0) return false;
    return r.bottom > h - 90 && r.top < h;
  }

  /* La classe qui efface la barre du total pendant que nous occupons le bas.
     Elle est posee sur la racine .scdm, jamais sur la barre elle-meme : ce
     noeud appartient a scdm-configurateur-clarte.js et personne d autre ne
     doit y ecrire. */
  function marquerLeBas() {
    if (!PANNEAU) return;
    var racine = PANNEAU.closest ? PANNEAU.closest('.scdm') : null;
    if (!racine) return;
    var occupe = occupeLeBas();
    if (occupe === racine.classList.contains('scdm-px-colle')) return;
    racine.classList.toggle('scdm-px-colle', occupe);
  }

  /* ==================================================================
     LE RENDU
     ==================================================================
     Un seul appel a calcul(). Tout le reste est de la mise en forme. */
  function peindre() {
    if (!poser()) return;
    replacer();
    var s = S(), d = D();
    if (!s || !d || typeof s.calcul !== 'function') return;

    var manque = manquePourLePrix();
    var interne = !!id('scdmInterneRacine');
    if (manque.length) {
      montrerAttente(langue('Choisissez ', 'Choose ') + liste(manque) +
        (interne ? langue(' pour préparer votre demande interne.', ' to prepare your internal request.') :
          langue(' pour voir votre prix.', ' to see your price.')));
      dernier = null;
      return;
    }

    var v = (typeof s.valide === 'function') ? s.valide() : { ok: true };

    /* CE QUI SE CHIFFRE SUR MESURE NE S AFFICHE PAS. scdm-limites.js pose
       « sansPrix » quand la configuration sort de ce qu une grille sait
       dire — aujourd hui, plus de 25 exemplaires sur plastique cannele.
       Montrer un chiffre quand meme serait annoncer un prix qu on ne veut
       pas honorer : au Quebec, un prix annonce doit etre honore.

       ON NE RECALCULE RIEN ET ON NE DECIDE RIEN ICI : la regle vit dans
       scdm-limites.js, le seul fichier qui la connaisse, et on se contente
       de lire son verdict. L encadre qu il peint juste au-dessus du bouton
       porte deja l explication et le chemin vers la soumission. */
    var lim = window.SCDM_LIMITES;
    if (lim && lim.sansPrix) {
      montrerDevis(lim.msg || texteAlerte('quote_volume', 'Ce volume se chiffre sur mesure.'));
      return;
    }

    if (!v.ok) {
      montrerDevis(v.msg || texteAlerte('quote_size', 'Ce format se chiffre sur soumission.'));
      return;
    }

    if (interne) {
      montrerAttente(langue('Préparez votre design, puis ajoutez-le à votre demande interne. Aucun paiement n’est demandé ici.',
        'Prepare your design, then add it to your internal request. No payment is requested here.'));
      dernier = null;
      return;
    }

    /* LE CALCUL. Celui de scdm.js, appele tel quel. */
    var c = s.calcul();
    var prix = prixAffiche(c);
    if (!prix) {
      montrerAttente(langue('Vérifiez la quantité et la configuration pour voir votre prix.',
        'Check the quantity and configuration to see your price.'));
      dernier = null;
      return;
    }

    var e = s.etat;
    var sig = signature(e), vals = valeurs(e);
    vals.qte = c.qte;

    PANNEAU.classList.remove('devis');
    elDevis.hidden = true;
    elAttente.hidden = true;
    elCorps.hidden = false;
    PANNEAU.hidden = false;

    elUnitLabel.textContent = prix.libelle;
    elUnit.textContent = (prix.approximatif ? '≈ ' : '') + argent(prix.unitaire);
    elTotal.textContent = argent(c.total);
    PANNEAU.setAttribute('aria-label',
      prix.libelle + ' ' + (prix.approximatif ? langue('environ ', 'approximately ') : '') +
      argent(prix.unitaire) + langue(', total de cette ligne ', ', line total ') + argent(c.total) + '.');

    /* L ECART */
    if (dernier && dernier.sig !== sig) {
      var txt = texteEcart(dernier.total, c.total, dernier.vals, vals, e);
      if (txt) {
        elEcart.textContent = txt;
        elEcart.className = 'scdm-px-ecart ' + (c.total > dernier.total ? 'hausse' : 'baisse');
        elEcart.hidden = false;
        ecartJusqua = Date.now() + DUREE_ECART;
      }
    } else if (elEcart && !elEcart.hidden && Date.now() > ecartJusqua) {
      elEcart.hidden = true;
    }
    dernier = { sig: sig, total: c.total, vals: vals };

    /* LE MINIMUM */
    peindreMinimum(c);
  }

  function peindreMinimum(c) {
    var s = S(), d = D();
    var plancher = Number(d.MIN_COMMANDE);
    if (!isFinite(plancher) || plancher <= 0) { elMin.hidden = true; return; }

    var t = (typeof s.totaux === 'function') ? s.totaux() : null;
    var deja = t ? (t.sous || 0) : 0;
    var projete = deja + c.total + montageAjoute(t ? (t.montage || 0) : 0);

    if (projete >= plancher - 0.005) { elMin.hidden = true; return; }
    var ecart = plancher - projete;
    elMin.innerHTML = '<b>' + htmlAlerte(texteAlerte('minimum_order', 'Minimum de commande : {amount}.', {amount:argent(plancher)})) + '</b> ' +
      htmlAlerte(texteAlerte('minimum_shortfall', 'Il manque {amount}. Ajoutez un autre design ou augmentez la quantité.', {amount:argent(ecart)}));
    elMin.hidden = false;
  }

  /* Le panneau en mode « pas de chiffre ». Meme corps que montrerAttente(),
     mais c est l encadre du devis qui parle et le panneau porte la classe
     « devis » : la feuille jumelle le peint autrement. */
  function montrerDevis(txt) {
    if (!PANNEAU) return;
    elAttente.hidden = true;
    elCorps.hidden = true;
    elEcart.hidden = true;
    elMin.hidden = true;
    elDevis.hidden = false;
    elDevis.textContent = txt;
    PANNEAU.classList.add('devis');
    PANNEAU.hidden = false;
    PANNEAU.removeAttribute('aria-label');
    dernier = null;
  }

  function montrerAttente(txt) {
    if (!PANNEAU) return;
    PANNEAU.classList.remove('devis');
    elDevis.hidden = true;
    elCorps.hidden = true;
    elEcart.hidden = true;
    elMin.hidden = true;
    elAttente.hidden = false;
    elAttente.textContent = txt;
    PANNEAU.hidden = false;
    PANNEAU.removeAttribute('aria-label');
  }

  function liste(l) {
    if (l.length === 1) return l[0];
    return l.slice(0, -1).join(', ') + langue(' et ', ' and ') + l[l.length - 1];
  }

  /* ==================================================================
     DEMARRAGE
     ==================================================================
     En phase de BULLE, donc apres scdm-panneau.js (capture) et apres les
     ecouteurs de scdm.js poses sur les conteneurs. Le setTimeout(0) laisse
     passer les redessins que ces ecouteurs declenchent : on lit l etat final,
     pas l intermediaire.

     Le filet a 250 ms rattrape ce qui change sans evenement : la rangee du
     support rigide que scdm-panneau.js reconstruit toute seule, la rangee du
     vernis qui se cache sur du lettrage, un design ajoute qui deplace le
     minimum. C est la meme cadence que les deux autres modules du
     configurateur. */
  function demarrer() {
    if (!id('scdmConfig')) return;
    poser();
    ['input', 'change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(peindre, 0); }, false);
    });
    setInterval(function () { peindre(); marquerLeBas(); }, 250);
    window.addEventListener('resize', function () { peindre(); marquerLeBas(); });
    /* Le defilement ne change aucun prix : on ne recalcule rien, on regarde
       seulement si le panneau a pris ou lache sa prise en bas de l ecran.
       En passif, pour ne pas retenir le defilement d un doigt. */
    window.addEventListener('scroll', marquerLeBas, { passive: true });
    peindre();
    marquerLeBas();
  }

  window.SCDM_PRIX_DIRECT = { occupeLeBas: occupeLeBas, peindre: peindre };

  function quandPret(n) {
    if (id('scdmConfig') && window.SCDM && window.SCDM.calcul && window.SCDM_DATA) return demarrer();
    if ((n || 0) > 200) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
